import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X, LayoutDashboard, LogOut } from "lucide-react";
import { Logo } from "./Logo";
import { LanguageSwitcher } from "./LanguageSwitcher";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LanguageContext";

export function Navbar() {
  const { user, logout } = useAuth();
  const { t } = useLang();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  const dash = user && user.role === "employer" ? "/employer" : user && user.role === "admin" ? "/admin" : "/dashboard";

  const doLogout = () => { logout(); nav("/"); };

  return (
    <header className="sticky top-0 z-50 border-b border-slate-200 bg-white/85 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <div className="flex items-center gap-8">
            <Logo />
            <nav className="hidden md:flex items-center gap-6 text-sm font-semibold text-slate-700">
              <Link to="/jobs" data-testid="nav-find-jobs" className="hover:text-brand-blue transition-colors">{t("nav_find_jobs")}</Link>
              <Link to="/find-people" data-testid="nav-find-people" className="hover:text-brand-blue transition-colors">{t("nav_find_people")}</Link>
              <Link to="/how-it-works" data-testid="nav-how" className="hover:text-brand-blue transition-colors">{t("nav_how")}</Link>
            </nav>
          </div>

          <div className="hidden md:flex items-center gap-2">
            <LanguageSwitcher />
            {user ? (
              <>
                <Link to={dash} data-testid="nav-dashboard" className="inline-flex items-center gap-2 rounded-xl px-3 py-2 text-sm font-semibold text-navy hover:bg-brand-bluelight transition-colors">
                  <LayoutDashboard className="h-4 w-4" /> {t("nav_dashboard")}
                </Link>
                <button onClick={doLogout} data-testid="nav-logout" className="inline-flex items-center gap-2 rounded-xl px-3 py-2 text-sm font-semibold text-slate-500 hover:text-red-500 transition-colors">
                  <LogOut className="h-4 w-4" />
                </button>
              </>
            ) : (
              <>
                <Link to="/login" data-testid="nav-login" className="rounded-xl px-4 py-2 text-sm font-semibold text-navy hover:bg-brand-bluelight transition-colors">{t("nav_login")}</Link>
                <Link to="/signup" data-testid="nav-signup" className="gjt-btn-orange rounded-xl px-4 py-2 text-sm font-bold">{t("nav_signup")}</Link>
              </>
            )}
          </div>

          <button className="md:hidden p-2" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
            {open ? <X className="h-6 w-6 text-navy" /> : <Menu className="h-6 w-6 text-navy" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-200 bg-white px-4 py-4 space-y-2">
          <Link to="/jobs" onClick={() => setOpen(false)} className="block py-2 font-semibold text-slate-700">{t("nav_find_jobs")}</Link>
          <Link to="/find-people" onClick={() => setOpen(false)} className="block py-2 font-semibold text-slate-700">{t("nav_find_people")}</Link>
          <Link to="/how-it-works" onClick={() => setOpen(false)} className="block py-2 font-semibold text-slate-700">{t("nav_how")}</Link>
          <div className="pt-2"><LanguageSwitcher /></div>
          {user ? (
            <>
              <Link to={dash} onClick={() => setOpen(false)} className="block py-2 font-semibold text-navy">{t("nav_dashboard")}</Link>
              <button onClick={() => { doLogout(); setOpen(false); }} className="block py-2 font-semibold text-red-500">{t("nav_logout")}</button>
            </>
          ) : (
            <div className="flex gap-2 pt-2">
              <Link to="/login" onClick={() => setOpen(false)} className="flex-1 rounded-xl border border-slate-200 px-4 py-2 text-center text-sm font-semibold text-navy">{t("nav_login")}</Link>
              <Link to="/signup" onClick={() => setOpen(false)} className="gjt-btn-orange flex-1 rounded-xl px-4 py-2 text-center text-sm font-bold">{t("nav_signup")}</Link>
            </div>
          )}
        </div>
      )}
    </header>
  );
}
